import type { BvIconValue } from '@bv/components/icon/partials/bv-icon-types.generated';

export enum LanguageCode {
  AR = 'ar',
  EN = 'en',
}

export interface LanguageConfig {
  code: LanguageCode;
  name: string;
  shortName: string;
  transKey: string;
  isRtl?: boolean;
  icon: BvIconValue;
}
